module.exports = __webpack_public_path__ + "img/infoTitle.4745b234.png";